import { render, staticRenderFns } from "./SavePrompt.vue?vue&type=template&id=27a00124"
import script from "./SavePrompt.vue?vue&type=script&lang=js"
export * from "./SavePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports